import { Box, Grid, Stack, TextField, Typography, Rating, Button } from '@mui/material';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import FavoriteIcon from '@mui/icons-material/Favorite';
import useMediaQuery from '@mui/material/useMediaQuery';
import { usePromoCodeApi } from '../../../api/promoCode';
import { useUserFeedbackApi } from '../../../api/userFeedback';
import { isEmailValid } from '../../../utils/miscellaneous';


const StyledRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
    color: theme.palette.action.disabled,
  },
}));
const NextButtonDefault = ({ btnText, onClick }) => {
  const isLaptop = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  return <Button
    sx={{
      minWidth: {
        xs: '150px',
        lg: "248px"
      },
      minHeight: {
        xs: '20px',
        lg: "30px"
      },
      padding: {
        sm: '12px 14px',
        lg: "12px 12px"
      },
      background: "linear-gradient(92deg, #72d8da 2.79%, #35c6c9 90.54%)",
      fontSize: "18px",
      // boxShadow: "0px 12px 30px 6px rgba(0, 0, 0, 0.05), 0px 18px 40px 10px rgba(0, 0, 0, 0.07)",
      boxShadow: "0px 35px 35px 0px rgba(0, 0, 0, 0.09), 0px 9px 19px 0px rgba(0, 0, 0, 0.1)",
      borderRadius: "40px",
      color: "#fff",
      textAlign: "center",
      fontSize: "20px",
      fontWeight: 600,
      "&:hover": {
        color: "#69D6D8",
        background: "white",
        border: "3px solid #72d8da !important"
      }
    }
    }
    onClick={onClick}
  >
    {btnText ? btnText : "Next"}
  </Button>
}
const customIcons = {
  1: {
    id: 1,
    icon: <SentimentVeryDissatisfiedIcon color="error" sx={{ fontSize: 40 }} />,
    label: 'Very Dissatisfied',
  },
  2: {
    id: 2,
    icon: <SentimentDissatisfiedIcon color="error" sx={{ fontSize: 40 }} />,
    label: 'Dissatisfied',
  },
  3: {
    id: 3,
    icon: <SentimentNeutralIcon color="warning" sx={{ fontSize: 40 }} />,
    label: 'Neutral',
  },
  4: {
    id: 4,
    icon: <SentimentVerySatisfiedIcon sx={{ color: '#e5c869', fontSize: 40 }} />,
    label: 'Satisfied',
  },
  5: {
    id: 5,
    icon: <FavoriteIcon color="success" sx={{ fontSize: 40 }} />,
    label: 'Very Satisfied',
  },
};

const recommendationList = [
  {
    value: 1,
    label: 'Not very likely',
  },
  {
    value: 2,
    label: '',
  },
  {
    value: 3,
    label: '',
  },
  {
    value: 4,
    label: '',
  },
  {
    value: 5,
    label: '',
  },
  {
    value: 6,
    label: '',
  },
  {
    value: 7,
    label: '',
  },
  {
    value: 8,
    label: '',
  },
  {
    value: 9,
    label: '',
  },
  {
    value: 10,
    label: 'Very likely',
  },
];

function IconContainer(props) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}

IconContainer.propTypes = {
  value: PropTypes.number.isRequired,
};

const textStyles = {
  fontSize: 14,
  fontWeight: 500,
  width: 'fit-content',
};
/**
 * React functional component representing the Thank You Page.
 * @component
 * @returns {JSX.Element} The rendered ThankYouPage component.
 */
export const ThankYouPage = () => {
    const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const [ratingRecommend, setRatingRecommend] = useState(0);
  const [ratingExperience, setRatingExperience] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [isFeedbackValidated, setIsFeedbackValidated] = useState(true);
  const [isRatingRecommendValidated, setIsRatingRecommendValidated] = useState(true);
  const [isRatingExpValidated, setIsRatingExpValidated] = useState(true);
  const [isEmailValidated, setIsEmailValidated] = useState(true);
  const [hasCreatedPromoCodeBefore, setHasCreatedPromoCodeBefore] = useState(false);
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const promoCodeApi = usePromoCodeApi();
  const userFeedbackApi = useUserFeedbackApi();


  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       // Check if the user has already given feedback
  //       const feedbackRes = await userFeedbackApi.hasGivenFeedback();
  //       console.log(feedbackRes);

  //       if (feedbackRes.data) {
  //         // Redirect to dashboard if feedback is already given
  //         navigate("/dashboard");
  //         return;
  //       }

  //       // If no feedback, check promo code
  //       const promoRes = await promoCodeApi.getVerifyUser();
  //       console.log(promoRes);
  //       if (promoRes.status === 200) {
  //         // Set the state based on the promo code response
  //         setHasCreatedPromoCodeBefore(promoRes.data.result);
  //       }

  //     } catch (err) {
  //       console.error("Error during API calls:", err);
  //     }
  //   };

  //   fetchData();
  // }, [])

  const handleSkip = () => {
    navigate("/dashboard");
  };

  const handleFinishAssessment = async () => {
    setIsFeedbackValidated(feedback !== '');
    setIsRatingRecommendValidated(ratingRecommend !== 0);
    setIsRatingExpValidated(ratingExperience !== 0);
    if (ratingRecommend === 0 || ratingExperience === 0 || feedback === '') return;

    await userFeedbackApi.postUserFeedback(ratingExperience, feedback, ratingRecommend, email ? email : 'None');

    navigate("/dashboard");
    // if (email === '') {
    //   window.location.href = 'https://www.Ai-md.com';
    //   return;
    // }

    // if (!isEmailValid(email)) {
    //   setIsEmailValidated(false);
    //   return;
    // }
    // setIsEmailValidated(true);
    // try {
    //   const response = await promoCodeApi.postEmailPromoCode();
    //   navigate('/');
    // } catch (error) {
    // }
  };

  const RatingButton = ({ value }) => {
    const [isHovered, setIsHovered] = useState(false);

    const mainColor = '#35c6c9';

    let mainStyles = {
      border: `2px solid ${mainColor}`,
      borderColor: mainColor,
      borderRadius: '50%',
      backgroundColor: 'transparent',
      color: mainColor,
      fontSize: '16px',
      textAlign: 'center',
      margin: '0',
      padding: value !== 10 ? '0.4rem 0.7rem' : '0.4rem',
      cursor: 'pointer',
      transition: `${mainColor} 0.2s, ${mainColor} 0.2s`,
    };

    if (value <= ratingRecommend || isHovered) {
      mainStyles.color = '#fff';
      mainStyles.backgroundColor = mainColor;
    }

    if (useMediaQuery('(max-width:450px)')) {
      mainStyles.padding = value !== 10 ? '0.2rem 0.45rem' : '0.2rem';
      mainStyles.fontSize = '14px';
    }
    if (useMediaQuery('(max-width:349px)')) {
      mainStyles.fontSize = '8px';
      mainStyles.padding = value !== 10 ? '0.3rem 0.4rem' : '0.3rem';
      mainStyles.fontWeight = 'bold';
    }
    if (useMediaQuery('(max-width:280px)')) {
      mainStyles.padding = value !== 10 ? '0.2rem 0.3rem' : '0.2rem';
    }

    return (
      <button
        key={value}
        onClick={() => setRatingRecommend(value)}
        onMouseOver={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={mainStyles}
      >
        {value}
      </button>
    );
  };

  return (

    <Box sx={{ display: "flex", flexDirection: "column", margin: "auto", width: "100%", justifyContent: "center", alignItems: "center" }}>
      <Box sx={{ mx: { sm: 0, md: 8 }, marginBottom: "70px" }} >
        <Typography variant="h4" textAlign="center" sx={{ mb: 3, mt: 2 }}>
          Share Your Feedback
        </Typography>
        <Typography variant="subtitle2" sx={{ mt: 3, mx: 2 }}>
          We'd love to know what you thought of your experience!
        </Typography>
        <Grid sx={{ m: 2 }}>
          <Grid item xs={12} md={5} sx={{ marginTop: 2 }} >
            <Stack>
              <Typography sx={{ fontWeight: 600 }}>How would you describe your experience with the app?</Typography>
              <StyledRating
                sx={{ maxWidth: '200px', }}
                name="highlight-selected-only"
                defaultValue={0}
                IconContainerComponent={IconContainer}
                getLabelText={value => customIcons[value].label}
                highlightSelectedOnly
                value={ratingExperience}
                onChange={event => {
                  setRatingExperience(Number(event.target.value));
                }}
              />
              {ratingExperience === 0 && !isRatingExpValidated ? (
                <Typography variant="caption" color="error" display="block" gutterBottom>
                  You must choose an option.
                </Typography>
              ) : (
                ''
              )}
            </Stack>
          </Grid>
          <Grid item xs={12} md={5} sx={{ marginTop: 7 }}>
            <Typography sx={{ fontWeight: 600 }}>
              Do you have any specific feedback (positive or negative) that you would like to point out?
            </Typography>
          </Grid>
          <Grid item xs={12} md={5} sx={{ marginTop: 1 }}>
            <Box m="auto">
              <TextField
                id="outlined-multiline-static"
                label=""
                multiline
                rows={5}
                sx={{
                  maxWidth: 500,
                  width: '100%',
                  backgroundColor: '#F5F5F561',
                  '& .MuiInput-input': {
                    pt: 1,
                    px: 1,
                  },
                  '& .MuiFormHelperText-root': { backgroundColor: '#FFFFFF' },
                }}
                variant="standard"
                onChange={event => {
                  setFeedback(event.target.value);
                }}
                error={!isFeedbackValidated ? true : false}
                helperText={feedback === '' && !isFeedbackValidated ? 'Type some feedback' : null}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={5} sx={{ marginTop: 7 }}>
            <Typography sx={{ fontWeight: 600 }}>
              How likely are you to recommend us to your friends and colleagues?
            </Typography>
          </Grid>
          <Grid item xs={12} md={5} sx={{ marginTop: 1 }}>
            <Stack>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  sx={{
                    maxWidth: '600px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: {
                      xs: 'space-between',
                    },
                    flexWrap: 'wrap',
                  }}
                >
                  {recommendationList.map((item, index) => (
                    <RatingButton key={index} value={item.value} />
                  ))}
                </Box>
              </div>
            </Stack>
          </Grid>
          <Box
            maxWidth={600}
            sx={{
              display: 'flex',
              mt: 2,
              justifyContent: 'space-between',
            }}
          >
            <Typography sx={{ mt: 2 }}>Not very likely</Typography>
            <Typography sx={{ mt: 2 }}>Very likely</Typography>
          </Box>
          <Grid item xs={12} md={5} sx={{ marginTop: 3 }}>
            {ratingRecommend === 0 && !isRatingRecommendValidated && (
              <Typography variant="caption" color="error" display="block" gutterBottom>
                You must choose an option.
              </Typography>
            )}
          </Grid>
          {/* {!hasCreatedPromoCodeBefore && (
            <>
              <Grid item xs={12} md={5} sx={{ marginTop: 7 }}>
                <Typography sx={{ fontWeight: 600 }}>We'd like to send you something!</Typography>
                <Typography sx={{ fontWeight: 400, fontSize: 13 }}>Enter your email</Typography>
              </Grid>
              <Grid item xs={12} md={5} sx={{ marginTop: 1 }}>
                <Box m="auto">
                  <TextField
                    id="email"
                    label=""
                    type="email"
                    sx={{ maxWidth: 500, width: '100%' }}
                    variant="standard"
                    onChange={event => {
                      setEmail(event.target.value);
                    }}
                  />
                  {!isEmailValidated ? (
                    <Typography variant="caption" color="error" display="block" gutterBottom>
                      Please type a correct email format
                    </Typography>
                  ) : (
                    ''
                  )}
                </Box>
              </Grid>
            </>
          )} */}
        </Grid>
      </Box>

      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" marginBottom="30px" >

        <Button sx={{
          padding : "12px 20px",
          minWidth : "248px",
          background: "linear-gradient(92deg, #72d8da 2.79%, #35c6c9 90.54%)",
          fontSize: "18px",
          boxShadow: "0px 35px 35px 0px rgba(0, 0, 0, 0.09), 0px 9px 19px 0px rgba(0, 0, 0, 0.1)",
          borderRadius: "40px",
          color: "#fff",
          textAlign: "center",
          fontSize: "20px",
          fontWeight: 600,
          border: "3px solid transparent !important",
          "&:hover": {
            color: "#69D6D8",
            background: "white",
            border: "3px solid #72d8da !important"
          }
        }
        }
        onClick={handleFinishAssessment}
        >
        
        Submit Feedback
        </Button>         
        <Button sx={{ paddingY : "24px",  fontSize: "20px", color : "gray"}} onClick={handleSkip}>Skip</Button>
      </Box>
     
    </Box>
  );
};
